import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../wallet.css';
import Select from 'react-select';
import ReportIssueButton from './ReportIssueButton';

const OutScan = () => {

  const API_URL = process.env.REACT_APP_API_URL;
  const [barcode, setBarcode] = useState('');
  const [shipmentDetails, setShipmentDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  // Handle the barcode scan (onChange or onKeyUp event)
  const handleBarcodeInputChange = (event) => {
    setBarcode(event.target.value);
  };



  const handleBarcodeKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevents form submission or unwanted behavior
      const scannedValue = barcode.trim();

      if (scannedValue) {
        processBarcode(scannedValue);
        setTimeout(() => setBarcode(''), 100); // Allow time for barcode to register
      }
    }
  };

  const processBarcode = (scannedValue) => {
   

    const scannedBarcodes = scannedValue
      .split(/[\n,]+/)
      .map(value => value.trim()) 
      .filter(value => value !== '') 
      .map(value => {
        if (value.startsWith('EKX')) {
          // Remove first 3 characters and last 5 characters
          return value.slice(3, -5);
        }
        return value;
      });

    setShipmentDetails((prevDetails) => [...prevDetails, ...scannedBarcodes]);
  };

  const buttonsyle = {
    background: '#00a6ed',
    color: '#fff',
    padding: '3px',
    marginRight: '10px',
    borderColor: '#00a6ed',
    cursor: 'pointer',
    marginTop: '3%'
  }

 


  useEffect(() => {
    // Fetch drivers from the API on component mount
    fetchDrivers();
    getHomebase()
    fetchProjects()
  }, []);

  // Optional finance Project to link the scanned AWBs to.
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const fetchProjects = async () => {
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/projects?active=true`);
      setProjects(res.data?.data || []);
    } catch (err) {
      // Project linking is optional; scanning works without it.
      console.warn('Could not load projects:', err.message);
    }
  };
  const projectOptions = (projects || []).map((p) => ({
    value: p.id,
    label: `${p.projectCode} — ${p.projectName}${p.partnerName ? ` (${p.partnerName})` : ''}`,
  }));

  const [scaninfo, setScaninfo] = useState({
    homebase: '',
    driver: ''
  })
  const [drivers, setDrivers] = useState()
  const [awb, setAwb] = useState([]);

  const [homebases, sethomebases] = useState([])
  const getHomebase = async () => {
    const API_PATH = `${API_URL}shypvdriverapp/homebase/getHomebases`;

    try {
      const res = await axios.get(API_PATH);
      console.log(res.data);
      if (res.data.success == true) {
        sethomebases(res.data.data);
      } else {
        console.log('false')
      }

    } catch (err) {
      console.log(err);
    }
  };


  console.log('homebases', homebases)
  const fetchDrivers = async () => {
    try {
      // Replace this API endpoint with the actual one that fetches drivers based on the emirate
      const response = await axios.get(`${API_URL}shypvdriverapp/driver/getAllDrivers`);

      if (response.data.success) {
        const driversData = response.data.data;  // The array of driver objects

        // Map the response to extract driverId and name
        const driversList = driversData.map(driver => ({
          driver_id: driver.driverId,
          driver_name: driver.name
        }));

        // Set the drivers state
        setDrivers(driversList);
      } else {
        console.error('Error fetching drivers for emirate:');
      }
    } catch (error) {
      console.error('Error fetching drivers:', error);
    }
  };

  console.log('scan:', scaninfo)
  const [msg, setMsg] = useState()
  const [errorMsg, setError] = useState()
 

  const [successMessages, setSuccessMessages] = useState([]);
  const [errorMessages, setErrorMessages] = useState([]);

  function doOutScan() {
    if (scaninfo.driver) {
      setError('')
      setMsg('')
      const payload = {
        // scan_date: scaninfo.scan_date,
        driver_id: scaninfo.driver,

        updated_by: sessionStorage.getItem('userid'),
        // order_id: scaninfo.scan_time,
        // status: "inscan",
        home_base: scaninfo.homebase,
        awbs: shipmentDetails
      };

      console.log('payload is', payload)
      setMsg('Processing...')
      axios.post(`${API_URL}shypvdriverapp/configure/dispatchPlanUsingBarcodeNew`, payload)
        .then(response => {
          console.log("Response:", response.data);




          if (response.data.data) {
            

            const jobId = response.data.data.requestId;
            console.log("Job Started. Job ID:", jobId);
            // alert(jobId)

            // Optional: link the scanned AWBs to a finance Project.
            // Best-effort — never block or fail the out-scan itself.
            if (selectedProject) {
              axios
                .post(`${API_URL}shypvdriverapp/projects/${selectedProject.value}/assign`, {
                  awbs: shipmentDetails,
                })
                .then((r) => console.log("Linked scanned AWBs to project", selectedProject.value, r.data))
                .catch((e) => console.warn("Project link failed (out-scan still ok):", e?.message));
            }

            // Step 2: Poll the job status until it is NOT "PENDING"
            const maxAttempts = 30;     // Maximum number of polling attempts
            const delayMs = 4000;       // Delay between each poll (2 seconds)

            const pollJobStatus = async (attempt = 1) => {
              try {
                const statusResponse = await axios.get(`${API_URL}shypvdriverapp/configure/dispatchStatus/${jobId}`);
                const status = statusResponse.data.STATUS;

                console.log(`Attempt ${attempt}: Job status is ${status}`);

                    if (status !== 'PENDING' && status !== 'QUEUED') {
                  console.log('✅ Job is complete:', statusResponse.data);

                  const awbs = statusResponse.data.data.awbs.split(',');
                  const errors = statusResponse.data.data.errors || []; // Default to an empty array if no errors

                  const successList = [];
                  const errorList = [];

                  awbs.forEach(awb => {
                    const errorDetail = errors.find(error => error.errorDetails.includes(awb));

                    if (errorDetail) {
                      // If an error exists for this AWB, add it to the error list
                      errorList.push(`${awb}: ${errorDetail.errorMessage}`);
                    } else {
                      // If no error is found, it's a success
                      successList.push(`${awb}: Success`);
                    }
                  });

                  // Update the state correctly
                  setSuccessMessages(successList);
                  setErrorMessages(errorList);

                  // Build the final message
                  let msg = '';
                  if (successList.length > 0) {
                    msg += `Success:\n${successList.join("\n")}\n`;
                  }
                  if (errorList.length > 0) {
                    if (msg) msg += "\n";
                    msg += `Errors:\n${errorList.join("\n")}`;
                  }
                  if (!msg) {
                    msg = "Processing.";
                  }

                  setMsg(msg);
                  setLoading(false);
                  return;
                }

                if (attempt < maxAttempts) {
                  setTimeout(() => pollJobStatus(attempt + 1), delayMs);
                } else {
                  console.warn('❌ Max retries reached. Job is still pending.');
                  setError('Timeout: Job did not complete in time.');
                  setLoading(false);
                }

              } catch (err) {
                console.error('Polling error:', err.response?.data || err.message);
                setError('Error checking job status.');
                setLoading(false);
              }
            };



            pollJobStatus();
          }


          if (response.data.errors && response.data.errors.length > 0) {
            response.data.errors.forEach(err => {
              if (Array.isArray(err.errorDetails)) {
                err.errorDetails.forEach(detail => {
                  errorMessages.push(` ${detail}`);
                });
              } else {
                errorMessages.push(`${err.errorDetails}`);
              }
            });
          }

          // Build the message with line breaks
          let msg = "";
          if (successMessages.length > 0) {
            msg += `Success:\n${successMessages.join("\n")}\n`;
          }
          if (errorMessages.length > 0) {
            if (msg) msg += "\n"; // add spacing if successes exist
            msg += `Errors:\n${errorMessages.join("\n")}`;
          }
          if (!msg) {
            msg = "Processing.";
          }

          // Set the message
          setMsg(msg);

        })
        .catch(error => {
          console.error("Error:", error);
          setMsg("An error occurred while dispatching orders.");
        });

    } else {
      setError('Please enter all the required fields')
    }
  }

  const handleDelete = (awbToDelete) => {
    // Filter out the AWB to delete
    const updatedDetails = shipmentDetails.filter((awb) => awb !== awbToDelete);
    setShipmentDetails(updatedDetails);
  };


  const [searchQuery, setSearchQuery] = useState("");

  const filteredDrivers = Array.isArray(drivers)
    ? drivers.filter(driver =>
      driver.driver_name.toLowerCase().includes(searchQuery.toLowerCase())
    )
    : [];

  const driverOptions = filteredDrivers.map(driver => ({
    value: driver.driver_id,
    label: `${driver.driver_id} - ${driver.driver_name}`
  }));

  const handleChange = (selectedOption) => {
    setScaninfo({ ...scaninfo, driver: selectedOption.value });
  };

  return (
    <div className="wallet-page">
      <ReportIssueButton pageContext="OUTSCAN" pageLabel="Pickup / Out Scan" awb={barcode} />
      <div className="w-topbar">
        <div className="w-topbar-left">
          <div className="w-icon-badge"><i className="fa fa-truck" aria-hidden="true" /></div>
          <div>
            <h2 className="w-title">Pickup / Out Scan</h2>
            <p className="w-subtitle">Scan AWBs out to a driver, optionally linked to a finance project.</p>
          </div>
        </div>
      </div>

      <div className="w-card">
        <div className="w-card-header">
          <span className="w-card-title"><i className="fa fa-user" aria-hidden="true" /> Scan details</span>
        </div>
        <div className="w-card-body">
          <div className="w-form-row">
            <div className="w-field" style={{ flex: '1 1 260px' }}>
              <label className="w-field-label" htmlFor="driver">Select Driver</label>
              <Select
                options={driverOptions}
                value={driverOptions.find(option => option.value === scaninfo.driver)}
                onChange={handleChange}
                placeholder="Select a driver"
                onInputChange={newValue => setSearchQuery(newValue)} // Update search query
                isSearchable
                noOptionsMessage={() => "No drivers found"}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>

            <div className="w-field" style={{ flex: '1 1 220px' }}>
              <label className="w-field-label" htmlFor="homebase">Select Homebase</label>
              <select
                id="homebase"
                className="w-select"
                style={{ width: '100%' }}
                value={scaninfo.homebase}
                onChange={(e) => setScaninfo({ ...scaninfo, homebase: e.target.value })}

              >
                <option value="">Select a Homebase</option>
                {homebases && homebases.map((homebase) => (
                  <option key={homebase.homebaseCode} value={homebase.homebaseCode}>
                    {homebase.homebaseName}
                  </option>
                ))}
              </select>
            </div>

            {/* Optional: link these out-scans to a finance Project */}
            <div className="w-field" style={{ flex: '1 1 260px' }}>
              <label className="w-field-label" htmlFor="project">Project (optional)</label>
              <Select
                options={projectOptions}
                value={selectedProject}
                onChange={setSelectedProject}
                placeholder="No project — don’t link"
                isClearable
                isSearchable
                noOptionsMessage={() => "No active projects"}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* Barcode Input */}
          <div className="w-field" style={{ marginBottom: 0 }}>
            <label className="w-field-label" htmlFor="awb-input">AWB</label>
            {/* <input
                        type="text"
                        value={barcode}
                        onChange={handleBarcodeInputChange}
                        onKeyUp={handleBarcodeKeyUp}
                        placeholder="Scan barcode and press Enter"
                        autoFocus
                    /> */}

            <textarea
              id="awb-input"
              className="w-textarea"
              value={barcode}
              onChange={handleBarcodeInputChange}
              // onKeyUp={handleBarcodeKeyUp}
              onKeyDown={handleBarcodeKeyDown}
              placeholder="Scan barcode and press Enter"
              autoFocus
            />
          </div>
        </div>
      </div>

      {(loading || shipmentDetails.length > 0) && (
        <div className="w-card">
          <div className="w-card-header">
            <span className="w-card-title"><i className="fa fa-list-alt" aria-hidden="true" /> Shipment Details</span>
            {shipmentDetails.length > 0 && <span className="w-card-meta">{shipmentDetails.length} scanned</span>}
          </div>
          <div className="w-card-body">
            {loading && <div className="w-loading"><i className="fa fa-spinner fa-spin" aria-hidden="true" /> Loading shipment details...</div>}

            {shipmentDetails.length > 0 && (
              <div>
                <div className="w-scan-list">
                  {shipmentDetails.map((awb, index) => (
                    //        <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                    //       <p key={index} style={{ textAlign: 'left', marginRight: '10px', marginBottom: '0' }}>{awb}</p>
                    //       <a
                    //   style={{ color: 'red', cursor: 'pointer', marginLeft: '10px' }}
                    //   onClick={() => handleDelete(awb)} // Delete this AWB when clicked
                    // >
                    //   <i className="fa fa-trash" />
                    // </a>
                    // </div>

                    <div key={index} className="w-scan-row">
                      <span className="w-scan-awb">{awb}</span>
                      <button
                        type="button"
                        className="w-scan-remove"
                        onClick={() => handleDelete(awb)} // Delete this AWB when clicked
                        aria-label="Remove"
                      >
                        <i className="fa fa-trash" aria-hidden="true" />
                      </button>
                    </div>

                  ))}
                </div>

                <button onClick={doOutScan} type="button" className="w-btn w-btn-primary" style={{ marginTop: 14 }}>
                  Submit
                </button>
                {msg && (
                  <pre className="w-result-pre">{msg}</pre>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {errorMsg && <div className="w-pill w-pill-danger" style={{ marginTop: 12 }}>{errorMsg}</div>}
    </div>
  );
};

export default OutScan;
